import { deleteCookie, getCookie, setCookie } from "./cookie";
const ISPAYLOADENCRYPTED = process.env.REACT_APP_IS_PAYLOAD_ENCRYPTED;
/**
 * Client
 * @module Client
 */

export class ServerError extends Error {
  constructor(message) {
    super(message);
    Error.captureStackTrace(this, ServerError);
    this.name = "ServerError";
    return this;
  }
}

export const parseError = (error) => {
  return error || "We couldn't process your request. Please try again later.";
};

const getEncodedURL = (url, payload) => {
  let encodedURL = new URL(url);
  Object.keys(payload).forEach((key) =>
    encodedURL.searchParams.append(key, payload[key])
  );
  return encodedURL;
};

/* ===================== ONLY TWO FUNCTIONS ===================== */
const SECRET_KEY_16 = process.env.REACT_APP_AES_KEY; // ← use the key backend gave you (16 chars)

console.log("ency", ISPAYLOADENCRYPTED, SECRET_KEY_16);

const ab2b64 = (ab) => {
  const u8 = ab instanceof Uint8Array ? ab : new Uint8Array(ab);
  let s = "";
  for (let i = 0; i < u8.length; i++) s += String.fromCharCode(u8[i]);
  return btoa(s);
};
const b642ab = (b64) => {
  const s = atob(b64);
  const u8 = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) u8[i] = s.charCodeAt(i);
  return u8.buffer;
};

export const encryptData = async (plaintext) => {
  const enc = new TextEncoder();
  const keyBytes = enc.encode(SECRET_KEY_16); // must be 16 bytes for AES-128
  const key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC", length: 128 },
    false,
    ["encrypt"]
  );
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const ct = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    enc.encode(String(plaintext))
  );
  return { data: ab2b64(ct), iv: ab2b64(iv) };
};

export const decryptData = async ({ data, iv }) => {
  const dec = new TextDecoder();
  const keyBytes = new TextEncoder().encode(SECRET_KEY_16);
  const key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC", length: 128 },
    false,
    ["decrypt"]
  );
  const pt = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv: new Uint8Array(b642ab(iv)) },
    key,
    b642ab(data)
  );
  return dec.decode(pt);
};
/* ===================== END TWO FUNCTIONS ===================== */

const encryptEachField = async (obj = {}, ignoreKeys = []) => {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (ignoreKeys.includes(k) || v === undefined) {
      out[k] = v;
      continue;
    }
    if (v === null) {
      out[k] = null;
      continue;
    }

    if (v instanceof File || v instanceof Blob) {
      // ✅ Do NOT encrypt files anymore. Just show small metadata in the console preview.
      out[k] = v;
      continue;
    }

    if (typeof v === "object") {
      // nested objects/arrays: encrypt their JSON string
      out[k] = await encryptData(JSON.stringify(v));
    } else {
      // primitives
      out[k] = await encryptData(String(v));
    }
  }
  return out;
};

// export const request = async (url, options = {}) => {
//   const config = {
//     method: "GET",
//     ...options,
//   };
//   const errors = [];

//   if (!url) {
//     errors.push("url");
//   }

//   if (
//     !config.payload &&
//     config.method !== "GET" &&
//     config.method !== "DELETE"
//   ) {
//     errors.push("payload");
//   }

//   if (errors.length) {
//     throw new Error(`Error! You must pass \`${errors.join("`, `")}\``);
//   }

//   let headers = {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   };
//   const authToken = getCookie("auth_token_admin");
//   const authTokenTrade = getCookie("auth_token_trade");
//   const isTradePlatform = window.location.pathname.includes("trade");

//   if ((authToken || authTokenTrade) && !options.disableAuthorization) {
//     headers.Authorization = `Bearer ${
//       isTradePlatform ? authTokenTrade : authToken
//     }`;
//   }
//   if (config.payload && config.payload.headers) {
//     headers = { ...headers, ...config.payload.headers };
//   }
//   if (config.headers) {
//     headers = { ...headers, ...config.headers };
//   }

//   const params = {
//     headers,
//     method: config.method,
//   };

//   // 🔽 inside request(), replace the whole non-GET block with this:
//   if (params.method !== "GET") {
//     // Build original body (unchanged)
//     const isFD = !!config.isFormData;
//     const bodyObj = isFD
//       ? Object.fromEntries((config.payload || new FormData()).entries())
//       : config.payload || {};
//     const bodyString = JSON.stringify(bodyObj);

//     // ---- Option A: whole-body preview (kept from before; remove if you don't want it)
//     try {
//       const env = await encryptData(bodyString);
//       console.log(
//         "%c[Encrypted Payload • PREVIEW ONLY]",
//         "color: teal; font-weight:700;",
//         env
//       );
//     } catch (err) {
//       console.warn("[encrypt whole-body preview failed]", err);
//     }

//     // ---- Option B: per-field preview (console only; sends normal payload)
//     // ---- Option B: per-field preview DEFAULT ON (console only; sends normal payload)
//     const doPerFieldPreview = config.encryptPerFieldPreview ?? true;
//     if (doPerFieldPreview) {
//       try {
//         const perFieldPreview = await encryptEachField(
//           bodyObj,
//           config.encryptIgnoreKeys ?? []
//         );
//         console.log(
//           "%c[Per-field Encrypted • PREVIEW ONLY]",
//           "color: purple; font-weight:700;",
//           perFieldPreview
//         );
//       } catch (err) {
//         console.warn("[encrypt per-field preview failed]", err);
//       }
//     }

//     // ---- Option C: send per-field envelopes
//     if (true) {
//       const perField = await encryptEachField(
//         bodyObj,
//         config.encryptIgnoreKeys || (isFD ? ["file", "files"] : [])
//       );
//       console.log(
//         "%c[Per-field Encrypted • SENT]",
//         "color: orange; font-weight:700;",
//         perField
//       );
//       const paramsTmp = new URLSearchParams();
//       Object.entries(perField).forEach(([key, value]) => {
//         paramsTmp.append(key, encodeURIComponent(JSON.stringify(value)));
//       });
//       // Send the per-field JSON; NOT multipart
//       params.body = paramsTmp.toString();
//       // keep Content-Type: application/json
//     } else {
//       // default: send original (unchanged)
//       params.body = isFD ? config.payload : bodyString;
//       if (isFD) delete params.headers["Content-Type"]; // let browser set boundary
//     }
//   } else {
//     url = getEncodedURL(url, config.payload || {});
//   }

//   /* ======================================================================== */

//   // if (config.isFormData) {
//   //   // kept EXACTLY as your original code (even though we now send JSON)
//   //   delete params.headers["Content-Type"];
//   // }

//   return fetch(url, params).then(async (response) => {
//     const contentType = response.headers.get("content-type");
//     if (response.status === 401) {
//       deleteCookie("auth_token_admin");
//       deleteCookie("access_token_expiry");
//       deleteCookie("user_details");
//       deleteCookie("role");
//       deleteCookie("availableRoles");
//       setCookie("session_expired", true);
//       window.location.pathname = "/";
//     }
//     if (response.status > 299) {
//       if (contentType && contentType.includes("application/json")) {
//         const res = await response.json();
//         const error = new Error(res.error || res.detail || res.message);
//         throw error;
//       } else {
//         const res = await response.text();
//         const error = new Error(res.error || res.detail || res.message);
//         throw error;
//       }
//     } else {
//       if (contentType && contentType.includes("application/json")) {
//         let rp = await response.json();
//         let encryptedData = await decryptData(rp);
//         console.log(encryptData, "encrypted");

//         return JSON.parse(encryptedData);
//       }
//       return response.text();
//     }
//   });
// };

export const request = async (url, options = {}) => {
  const config = {
    method: "GET",
    ...options,
  };
  const errors = [];

  if (!url) {
    errors.push("url");
  }

  if (
    !config.payload &&
    config.method !== "GET" &&
    config.method !== "DELETE"
  ) {
    errors.push("payload");
  }

  if (errors.length) {
    throw new Error(`Error! You must pass \`${errors.join("`, `")}\``);
  }

  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const authToken = getCookie("auth_token_admin");
  const authTokenTrade = getCookie("auth_token_trade");
  const isTradePlatform = window.location.pathname.includes("trade");

  if ((authToken || authTokenTrade) && !options.disableAuthorization) {
    headers.Authorization = `Bearer ${
      isTradePlatform ? authTokenTrade : authToken
    }`;
  }
  if (config.payload && config.payload.headers) {
    headers = { ...headers, ...config.payload.headers };
  }
  if (config.headers) {
    headers = { ...headers, ...config.headers };
  }
  const params = {
    headers,
    method: config.method,
  };
  if (params.method !== "GET") {
    if (ISPAYLOADENCRYPTED) {
      const isFD = !!config.isFormData;
      if (isFD) {
        const perField = await encryptEachField(
          Object.fromEntries((config.payload || new FormData()).entries()),
          config.encryptIgnoreKeys || (isFD ? ["file", "files"] : [])
        );
        const isFileInclude = Object.entries(perField)?.find(
          ([Key, value]) => value instanceof File
        );
        if (isFileInclude) {
          const formDataTmp = new FormData();

          Object.entries(perField).forEach(([key, value]) => {
            if (value instanceof File) {
              // ✅ Don't encrypt files
              formDataTmp.append(key, value);
            } else {
              // ✅ Encrypt everything else (already encrypted)
              // Must stringify so backend can parse JSON
              formDataTmp.append(key, JSON.stringify(value));
            }
            params.body = formDataTmp;
            delete params.headers["Content-Type"];
          });
        } else {
          const paramsTmp = new URLSearchParams();
          Object.entries(perField).forEach(([key, value]) => {
            paramsTmp.append(key, encodeURIComponent(JSON.stringify(value)));
          });
          // Send the per-field JSON; NOT multipart
          params.body = paramsTmp.toString();
        }
      } else {
        const bodyString = JSON.stringify(config.payload || {});
        const paramsTmp = await encryptData(bodyString);
        params.body = JSON.stringify(paramsTmp);
      }
    } else {
      params.body = config.isFormData
        ? config.payload
        : JSON.stringify(config.payload);
      if (config.isFormData) {
        delete params.headers["Content-Type"];
      }
    }
  } else {
    url = getEncodedURL(url, config.payload || {});
  }
  // if (config.isFormData) {
  //   delete params.headers["Content-Type"];
  // }

  return fetch(url, params).then(async (response) => {
    const contentType = response.headers.get("content-type");
    if (response.status === 401) {
      deleteCookie("auth_token_admin");
      deleteCookie("access_token_expiry");
      deleteCookie("user_details");
      deleteCookie("role");
      deleteCookie("availableRoles");
      setCookie("session_expired", true);
      window.location.pathname = "/";
    }
    if (response.status > 299) {
      // const error = new ServerError(response.statusText)
      // error.status = response.status

      if (contentType && contentType.includes("application/json")) {
        let res = null;
        if (ISPAYLOADENCRYPTED) {
          let rp = await response.json();
          let encryptedData = await decryptData(rp);
          res = encryptedData;
        } else {
          res = response.json();
        }
        // error.response = await response.json()
        const error = new Error(res.error || res.detail || res.message);
        throw error;
      } else {
        const res = await response.text();
        // error.response = await response.json()
        const error = new Error(res.error || res.detail || res.message);
        throw error;
      }
    } else {
      if (contentType && contentType.includes("application/json")) {
        if (ISPAYLOADENCRYPTED) {
          let rp = await response.json();
          let encryptedData = await decryptData(rp);

          return JSON.parse(encryptedData);
        } else {
          return response.json();
        }
      }
      return response.text();
    }
  });
};
